export default {

  platform: '',
  userLocationCode: 0,
  isLogin: false,
  accountConfirmed: false,
  usernameConfirmed: false
}




// WEBPACK FOOTER //
// ./src/vuex/state.js